var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_17599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86087 11.777L0.527296 7.44345C0.266943 7.18309 0.266943 6.76096 0.527296 6.50058L1.47014 5.55772C1.73049 5.29734 2.15265 5.29734 2.413 5.55772L5.3323 8.47699L11.5851 2.2242C11.8455 1.96384 12.2676 1.96384 12.528 2.2242L13.4708 3.16706C13.7312 3.42741 13.7312 3.84955 13.4708 4.10993L5.80374 11.7771C5.54336 12.0374 5.12123 12.0374 4.86087 11.777Z",
    fill: "url(#paint0_linear_840_17599)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_17599",
    x1: -14.9069,
    y1: 7.00062,
    x2: 9.85636,
    y2: 7.00062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_17599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3341,
    height: 13.3341,
    fill: "white",
    transform: "translate(0.332031 0.333618)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.834f8998aed7eca81dc2c3ab113d16e9.svg";
export { ForwardRef as ReactComponent };